import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class HoverService {
  hoverIDs: number[] = [];
  activeHoverID: number;
  onHoverShow: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  showHover(id: number) {
    this.activeHoverID = id;
    this.onHoverShow.emit(this.activeHoverID);
  }

  generateHoverID(): number {
    let id = Math.floor(Math.random() * 10000);
    if (this.hoverIDs.indexOf(id) === -1) {
      this.hoverIDs.push(id);
      return id;
    } else return this.generateHoverID();
  }

  removeHoverID(id: number) {
    let i = this.hoverIDs.indexOf(id);
    if (i > -1) this.hoverIDs.splice(i, 1);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/hover/hover.service.ts